import Types from "./Types";

export const GetDashboardDataSuccess = (payload) => ({
  type: Types.GET_DASHBOARD_DATA_SUCCESS,
  payload,
});

export const DashboardLoading = (payload) => ({
  type: Types.DASHBOARD_LOADING,
  payload,
});

export const GetBestSellingProductsSuccess = (payload) => ({
  type: Types.GET_BEST_SELLING_PRODUCTS_SUCCESS,
  payload,
});

export const GetSalesReportSuccess = (payload) => ({
  type: Types.GET_SALES_REPORT_SUCCESS,
  payload,
});

export const GetSoldQuantitiesReportSuccess = (payload) => ({
  type: Types.GET_SOLD_QUANTITIES_REPORT_SUCCESS,
  payload,
});

export const GetVatReportSuccess = (payload) => ({
  type: Types.GET_VAT_REPORT_SUCCESS,
  payload,
});
